'use client';

import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {ThemeContext} from 'styled-components';
import NibLogo, {NibLogomark, NibWordmark, NibArrow} from './brands/nib';
import NibLegacyLogo from './brands/nibLegacy';
import NibThrive from './brands/nibThrive';
import GuLogo from './brands/gu';
import QantasLogo from './brands/qantas';
import SuncorpLogo from './brands/suncorp';
import ApiaLogo from './brands/apia';
import AamiLogo from './brands/aami';
import NsiLogo from './brands/nsi';
import CotaLogo from './brands/cota';
import TalLogo from './brands/tal';
import ImanLogo from './brands/iman';
import FoundationLogo from './brands/foundation';
import IngLogo from './brands/ing';
import PricelineLogo from './brands/priceline';
import WorldNomadsLogo from './brands/worldNomads';
import AustralianSeniorsLogo from './brands/australianSeniors';
import RealLogo from './brands/real';
import {sizePropType} from './utils';
import {LogoComponent} from './types';
import AanzLogo from './brands/aanz';
import EdiLogo from './brands/edi';
import TidLogo from './brands/tid';

export type {LogoProps} from './types';

// eslint-disable-next-line @typescript-eslint/ban-types
const Logo: LogoComponent<{innerRef?: unknown}> = props => {
  const themeContext = useContext(ThemeContext);

  const {
    innerRef, // eslint-disable-line @typescript-eslint/no-unused-vars, react/prop-types
    size,
    ...otherProps
  } = props;

  // We use the theme selector to look at which brand the theme is using and then render the appropriate logo from that.
  // No need to manually pass in a prop :)
  switch (themeContext.id) {
    case 'ing':
      return <IngLogo size={size} {...otherProps} />;

    case 'qantas':
      return <QantasLogo size={size} {...otherProps} />;

    case 'gu':
      return <GuLogo size={size} {...otherProps} />;

    case 'suncorp':
      return <SuncorpLogo size={size} {...otherProps} />;

    case 'apia':
      return <ApiaLogo size={size} {...otherProps} />;

    case 'aami':
      return <AamiLogo size={size} {...otherProps} />;

    case 'nsi':
      return <NsiLogo size={size} {...otherProps} />;

    case 'cota':
      return <CotaLogo size={size} {...otherProps} />;

    case 'tal':
      return <TalLogo size={size} {...otherProps} />;

    case 'iman':
      return <ImanLogo size={size} {...otherProps} />;

    case 'foundation':
      return <FoundationLogo size={size} {...otherProps} />;

    case 'priceline':
      return <PricelineLogo size={size} {...otherProps} />;

    case 'worldNomads':
      return <WorldNomadsLogo size={size} {...otherProps} />;

    case 'nibLegacy':
      return <NibLegacyLogo size={size} {...otherProps} />;

    case 'australianSeniors':
      return <AustralianSeniorsLogo size={size} {...otherProps} />;

    case 'real':
      return <RealLogo size={size} {...otherProps} />;

    case 'aanz':
      return <AanzLogo size={size} {...otherProps} />;

    case 'edi':
      return <EdiLogo size={size} {...otherProps} />;

    case 'tid':
      return <TidLogo size={size} {...otherProps} />;

    case 'nib':
    default:
      return <NibLogo size={size} {...otherProps} />;
  }
};

Logo.displayName = 'Logo';

Logo.propTypes = {
  invert: PropTypes.bool,
  size: sizePropType
};

Logo.defaultProps = {
  invert: false,
  size: 'small'
};

export {
  NibLogo,
  NibLogomark,
  NibWordmark,
  NibArrow,
  NibLegacyLogo,
  NibThrive,
  GuLogo,
  QantasLogo,
  SuncorpLogo,
  ApiaLogo,
  TalLogo,
  ImanLogo,
  FoundationLogo,
  PricelineLogo,
  WorldNomadsLogo,
  NsiLogo,
  CotaLogo,
  AustralianSeniorsLogo,
  RealLogo,
  AanzLogo,
  EdiLogo
};
export default Logo;
